import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Clear from '@mui/icons-material/Clear';
import React from 'react';
import './table.scss';

interface GeneralSearchProps {
    dataRef?: React.RefObject<any> | any;
    handleSearchChange: (data: any) => void;
}

/**
 * @param dataRef - accepts an array of data objects and filters them.
 * @returns
 */
const GeneralSearch: React.FC<GeneralSearchProps> = ({ dataRef, handleSearchChange }) => {
    const [searchValue, setSearchValue] = React.useState<string>('');
    const [workingRef, setWorkingRef] = React.useState<any>(null);
    const [prefilteredData, setPrefilteredData] = React.useState<any>(null);

    React.useEffect(() => {
        if (dataRef && prefilteredData == null) {
            setPrefilteredData(dataRef);
        }
    }, [dataRef]);

    React.useEffect(() => {
        if (dataRef) {
            setWorkingRef(dataRef);
        }
    }, [dataRef]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchValue(value);
        const data = workingRef?.current;
        const lowerCaseValue = value.toLowerCase().trim();
        setTimeout(() => {
            const results = data?.filter((item: any) =>
                Object.values(item).some((val) => String(val).toLowerCase().includes(lowerCaseValue))
            );
            handleSearchChange(results);
        }, 1300);
    };

    const handleClearSearch = () => {
        setSearchValue('');
        setWorkingRef(prefilteredData);
        handleSearchChange(prefilteredData?.current);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'start',
                whiteSpace: 'nowrap',
                alignItems: 'center',
                gap: '7px',
                color: 'white'
            }}
        >
            <TextField
                fullWidth
                value={searchValue}
                placeholder="חפש"
                onChange={handleChange}
                variant="outlined"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: searchValue && (
                        <InputAdornment position="start">
                            <IconButton onClick={handleClearSearch}>
                                <Clear style={{ color: 'red' }} />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        border: '1px solid black',
                        maxHeight: 'max-content'
                    }
                }}
            />
        </Box>
    );
};

export default GeneralSearch;
